import { createAction } from '@reduxjs/toolkit';

export const fetchEpicDataSuccess = createAction('[EpicIntegration] fetchEpicDataSuccess');
export const fetchEpicDataFail = createAction('[EpicIntegration] fetchEpicDataFail');
